export default "__VITE_ASSET__CjD1ztX1__"